// Factory treats keys in a case insensitively...
// so they do not need to match the class name.

import updateCheck from 'src/update-check';

/* eslint-disable import/no-dynamic-require */
/* eslint-disable array-bracket-spacing */
/** @type {Record<string, DynamicImportCallback>} */
const dependencies = {
  // SHARED
  genericsearchbar: cb =>
    require([
      /* webpackChunkName: 'Search' */ 'gisw/Widgets/GenericSearch/Search'
      // @ts-ignore
    ], cb),
  loginpage: cb =>
    // @ts-ignore
    require([/* webpackChunkName: 'Login' */ 'gisw/Widgets/Login/Login'], cb),
  helppage: cb =>
    require([
      /* webpackChunkName: 'HelpPage' */ 'eCounty/Widgets/HelpPage'
      // @ts-ignore
    ], cb),
  resultspanel: cb =>
    require([
      /* webpackChunkName: 'ResultsPanel' */
      'gisw/Widgets/GenericSearch/ResultsPanel'
      // @ts-ignore
    ], cb),
  // @ts-ignore
  cartpanel: cb => require(['gisw/Tools/Payment/Cart'], cb),

  // TOOLS
  activitymanagement: cb =>
    require([
      /* webpackChunkName: 'ActivityManagement' */
      'gisw/Tools/ActivityManagement/ActivityManagement'
      // @ts-ignore
    ], cb),
  // @ts-ignore
  address: cb => require(['gisw/Tools/Address/Address'], cb),
  alwaysonidentify: cb =>
    // @ts-ignore
    require(['gisw/Tools/AlwaysOnIdentify/AlwaysOnIdentify'], cb),
  // @ts-ignore
  bratio: cb => require(['gisw/Tools/BRatio/BRatio'], cb),
  // @ts-ignore
  buffer: cb => require(['gisw/Tools/Buffer/Buffer'], cb),
  // @ts-ignore
  bookmark: cb => require(['gisw/Tools/Bookmark/Bookmark'], cb),
  bulkimageuploader: cb =>
    // @ts-ignore
    require(['gisw/Tools/BulkImageUploader/BulkImageUploader'], cb),
  // @ts-ignore
  dmat: cb => require(['gisw/Tools/DMAT/DMAT'], cb),
  draw: cb =>
    // @ts-ignore
    require(['gisw/Tools/Draw/Draw'], cb),
  // @ts-ignore
  identify: cb => require(['gisw/Tools/Identify/Identify'], cb),
  // @ts-ignore
  landuse: cb => require(['gisw/Tools/Landuse/Landuse'], cb),
  mapnavigation: cb =>
    // @ts-ignore
    require(['gisw/Tools/MapNavigation/MapNavigation'], cb),
  // @ts-ignore
  full_extent: cb => require(['gisw/Tools/OffOnTool/OffOnTool'], cb),
  // @ts-ignore
  zoom_in: cb => require(['gisw/Tools/OffOnTool/OffOnTool'], cb),
  // @ts-ignore
  zoom_out: cb => require(['gisw/Tools/OffOnTool/OffOnTool'], cb),
  zoom_to_previous_extent: cb =>
    // @ts-ignore
    require(['gisw/Tools/OffOnTool/OffOnTool'], cb),
  // @ts-ignore
  zoom_to_next_extent: cb => require(['gisw/Tools/OffOnTool/OffOnTool'], cb),
  // @ts-ignore
  clear_: cb => require(['gisw/Tools/OffOnTool/OffOnTool'], cb),
  // @ts-ignore
  pan: cb => require(['gisw/Tools/OffOnTool/OffOnTool'], cb),
  // @ts-ignore
  measure: cb => require(['gisw/Tools/Measure/Measure'], cb),
  personalproperty: cb =>
    // @ts-ignore
    require(['gisw/Tools/PersonalProperty/PersonalProperty'], cb),
  // @ts-ignore
  pictometry: cb => require(['gisw/Tools/Pictometry/Pictometry'], cb),
  // @ts-ignore
  print: cb => require(['gisw/Tools/Print/Print'], cb),
  // @ts-ignore
  photo: cb => require(['gisw/Tools/Photo/Photo'], cb),
  // @ts-ignore
  plume: cb => require(['gisw/Tools/Identify/Identify'], cb),
  bookmarkpublic: cb =>
    // @ts-ignore
    require(['gisw/Tools/Bookmark/Public/PublicBookmark'], cb),
  salessearch: cb => require(['gisw/Widgets/SalesSearch/SalesSearch'], cb),
  // @ts-ignore
  quicksearch: cb => require(['gisw/Widgets/QuickSearch/QuickSearch'], cb),
  instrumentsearch: cb =>
    // @ts-ignore
    require(['gisw/Widgets/InstrumentSearch/InstrumentSearch'], cb),
  // @ts-ignore
  paymentpanel: cb => require(['gisw/Tools/Payment/Payment'], cb),
  // @ts-ignore
  subscription: cb => require(['gisw/Tools/Subscription/Subscription'], cb),
  // @ts-ignore
  editor: cb => require(['eCity/Tools/Editor/Editor'], cb),
  weedsinfestation: cb =>
    // @ts-ignore
    require(['gisw/Tools/WeedsInfestation/WeedsInfestation'], cb),
  // @ts-ignore
  current_location: cb => require(['gisw/Tools/OffOnTool/OffOnTool'], cb),
  // @ts-ignore
  pindrop: cb => require(['eCity/Tools/PinDropTool/PinDropTool'], cb),
  publicnotice: cb =>
    // @ts-ignore
    require(['gisw/Tools/PublicNotice/PublicNotice'], cb),
  roadsprojectmanagement: cb =>
    // @ts-ignore
    require(['gisw/Tools/RoadsProjectManagement/RoadsProjectManagement'], cb),
  // @ts-ignore
  reportbuilder: cb =>
    // @ts-ignore
    require(['gisw/Tools/ReportBuilder/ReportBuilder'], cb),
  // @ts-ignore
  tmrm: cb => require(['gisw/Tools/TMRM/TMRM'], cb)
};

/**
 * @callback DynamicImportCallback
 * @param {any} module
 * @returns {void}
 */
/* eslint-enable array-bracket-spacing */
/* eslint-enable import/no-dynamic-require */

/**
 * a factory for lazy-loading classes.
 */
class Factory {
  constructor () {
    /** @type {Record<string, any>} */
    this._cache = {};
  }

  /**
   * Load and create classes
   * @template {FactoryTypes.ModuleNames} T
   * @param {object} options
   * @param {T} options.name Name of tool/module to be loaded
   * @param {HTMLElement} [options.node]
   * DOM element replaced by the root node of the created class
   * @param {object} options.params
   * Passed to the constructor of the class
   * @returns {Promise<FactoryTypes.ModuleMap[T]>}
   */
  async Create (options) {
    // @ts-ignore
    options.name = options.name.toLowerCase();

    if (this._cache.hasOwnProperty(options.name)) {
      const mod = this._cache[options.name];
      const Constructor = mod.default || mod;

      return new Constructor(options.params, options.node);
    }

    if (!dependencies.hasOwnProperty(options.name)) {
      return null;
    }

    try {
      const tool = await new Promise(resolve => {
        dependencies[options.name](MyObj => {
          this._cache[options.name] = MyObj;

          const Constructor = MyObj.default || MyObj;
          resolve(new Constructor(options.params, options.node));
        });
      });

      return tool;
    } catch (error) {
      updateCheck();
      throw error;
    }
  }
}

export default Factory;
